import { routes } from "@/constants/routes";
import { Redirect, useLocalSearchParams } from "expo-router";

function param(value: string | string[] | undefined): string {
  if (typeof value === "string") return value;
  return value?.[0] ?? "";
}

/** Vereinsroot bleibt nie leer: mit Zugriff zur Mitgliederliste. */
export default function TenantIndex() {
  const tenantID = param(useLocalSearchParams<{ tenantID: string }>().tenantID);
  if (!tenantID) return null;
  return <Redirect href={routes.tenant.members(tenantID) as never} />;
}
